import { warn } from 'cc';
import Game from '../../../common/scripts/Game';
import GameSharedAsset from '../Game/GameSharedAsset';
import GameDefine, { tableGameDefine } from '../Game/Data/Config/GameDefine';
import { ModelName, ModelType } from '../Game/Data/Config/ModelConfig';
import Model from '../../../common/scripts/Toolkit/Helper/Model';
import TableSceneManager from '../Game/TableSceneManager';
import Connection from '../../../common/scripts/Connection/Connection';
import { IRequestResponseDataType, PublishDataType } from '../Game/Data/Config/PathConfig';
import GameContext from '../Game/GameEntity/GameContext';

export default abstract class TableGame extends Game {
    protected static instance: TableGame = null;

    // protected declare _config: TableEnvironmentConfigType;
    protected gameSharedAsset: GameSharedAsset = null;
    protected gameDefine: GameDefine = tableGameDefine;
    protected gameContext: GameContext = null;
    protected modelMap: { [value in keyof ModelType]: Model } = null;
    protected _gameSharedAsset: GameSharedAsset;
    protected _connection: Connection<IRequestResponseDataType, PublishDataType>;

    public static get Instance() {
        if (!this.instance) {
            warn('no game instance has been instantiated');
            return null;
        }
        return this.instance;
    }

    public static get sharedAsset() {
        return this.Instance._gameSharedAsset;
    }
    public static set sharedAsset(value: GameSharedAsset) {
        this.Instance._gameSharedAsset = value;
    }

    public static get define(): GameDefine {
        return this.Instance.gameDefine;
    }

    public static get currentTable() {
        return this.hall.currentTable ?? null;
    }

    public static get scene() {
        return super.scene as TableSceneManager;
    }
    public static set scene(value: TableSceneManager) {
        super.scene = value;
    }

    // 桌內使用
    public static get context(): GameContext {
        return GameContext.currentContext;
    }

    public static get user() {
        return this.getModel(ModelName.User);
    }

    public static get hall() {
        return this.getModel(ModelName.Hall);
    }

    public static get history() {
        return this.getModel(ModelName.History);
    }

    public static get setting() {
        return this.getModel(ModelName.Setting);
    }

    public static get jackpot() {
        return this.getModel(ModelName.Jackpot);
    }

    public static get debug() {
        return this.getModel(ModelName.Debug);
    }

    protected static getModel<T extends ModelName>(modelName: T): ModelType[T] {
        return this.Instance?.modelMap[modelName] as ModelType[T];
    }

    protected afterGameLaunched(): void {
        this.initModels();
    }

    protected handleGlobalError() {
        // cancel global error handling, because streaming player will throw error unexpectedly
    }

    protected abstract initModels(): void;
}
